"use strict";

exports.__esModule = true;
exports.EditButtonsContainer = exports.DataItemTag = exports.ChartTitle = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
var _core = require("@blueprintjs/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ChartTitle = exports.ChartTitle = _styledComponents["default"].div.withConfig({
  displayName: "styles__ChartTitle",
  componentId: "sc-1adk033-0"
})(["width:", "px;height:", "px;padding:auto;text-align:center;font-size:", ";"], function (props) {
  return props.width;
}, function (props) {
  return props.chartTitleHeight;
}, (0, _Theme.val)("fontSizeXS"));
var DataItemTag = exports.DataItemTag = (0, _styledComponents["default"])(_core.Tag).withConfig({
  displayName: "styles__DataItemTag",
  componentId: "sc-1adk033-1"
})(["margin:1px 0px 1px 5px;"]);

// .attrs() rather than defaultProps: React 19 drops defaultProps for
// function components, and a styled component is one.
var EditButtonsContainer = exports.EditButtonsContainer = _styledComponents["default"].div.attrs({
  "data-testid": "DataItemChartElement.EditButtonsContainer"
}).withConfig({
  displayName: "styles__EditButtonsContainer",
  componentId: "sc-1adk033-2"
})(["display:flex;position:absolute;top:", ";right:", ";& > *{margin-left:5px;background-color:rgba(220,220,220,0.4);}z-index:10;justify-content:flex-end;flex-direction:row;"], function (props) {
  return props.toolboxEnabled ? '0px' : '2px';
}, function (props) {
  return props.toolboxEnabled ? '38px' : '5px';
});